import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import 'lib-flexible'
// import './rem'

// import Vconsole from 'vconsole';
// new Vconsole();

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.filter('dateFormat', function (datetime, fmt) {
  if (datetime === '' || datetime == null) {
    return ''
  } else {
    const date = new Date(datetime)
    let ret
    const opt = {
      'Y+': date.getFullYear().toString(), // 年
      'm+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'H+': date.getHours().toString(), // 时
      'M+': date.getMinutes().toString(), // 分
      'S+': date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    }
    for (const k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt)
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
      };
    };
    return fmt
  }
})
// router.beforeEach((to, from, next) => {
//   // to and from are both route objects. must call `next`.
//   if (to.path === '/login') {
//     window.sessionStorage.removeItem('model_username')
//   }
//   const username = window.sessionStorage.getItem('model_username');
//   if (to.matched.length > 0 && to.matched[0].meta.requireAuth) {
//     if (username == null) {
//       next({ path: '/login' })
//     }
//     else{
//       next();
//     }
//   } else {
//     next();
//   }
// })


new Vue({
  router,
  store,
  //vuetify,
  render: h => h(App)
}).$mount('#app')